import { __ } from '@wordpress/i18n';

const showMoreContainers = document.querySelectorAll('.component-show-more');

function createButton() {
	const button = document.createElement('button');
	const buttonWrapper = document.createElement('div');
	const icon = document.createElement('span');
	icon.className = 'icon icon-maximize';
	button.textContent = __('Show More', 'propel');
	button.appendChild(icon);
	button.className = 'component-show-more-button';
	buttonWrapper.className = 'component-show-more-button-wrapper container';
	buttonWrapper.appendChild(button);
	return buttonWrapper;
}

function updateVisibility(cards, visibleCount, btn) {
	cards.forEach((card, i) => {
		if (i < visibleCount) {
			card.classList.add('show-more-visible');
		} else {
			card.classList.remove('show-more-visible');
		}
	});
	if (visibleCount >= cards.length && btn) {
		btn.classList.remove('active');
	} else if (btn) {
		btn.classList.add('active');
	}
}

function setContainers() {
	showMoreContainers.forEach((container) => {
		const cards = container.querySelectorAll('.component-show-more-card');
		const visibleCount = parseInt(container.dataset.showMore, 10) || 16;
		const cardsCount = cards.length;

		if (visibleCount <= cardsCount) {
			const newButton = createButton();
			container.appendChild(newButton);
			updateVisibility(cards, visibleCount, newButton);
			newButton.addEventListener('click', () => {
				const currentVisibleCount = container.querySelectorAll(
					'.component-show-more-card:not([style*="display: none"])'
				).length;
				const newVisibleCount = currentVisibleCount + visibleCount;
				updateVisibility(cards, newVisibleCount, newButton);
			});
		} else {
			// Show all cards if the visible count is greater than the number of cards.
			updateVisibility(cards, visibleCount, null);
		}
	});
}

if (showMoreContainers.length) {
	setContainers();
}
